import { render, staticRenderFns } from "./VoucherAndRoomInformation.vue?vue&type=template&id=2bb6bbc1&scoped=true"
import script from "./VoucherAndRoomInformation.vue?vue&type=script&lang=js"
export * from "./VoucherAndRoomInformation.vue?vue&type=script&lang=js"
import style0 from "./VoucherAndRoomInformation.vue?vue&type=style&index=0&id=2bb6bbc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6bbc1",
  null
  
)

export default component.exports